import { connect } from 'react-redux';
import { withRouter, Route } from 'react-router-dom';
import { withAuth } from 'components/provider/Auth';
import LoginRedirect from '../LoginRedirect';
import NotFound from 'components/route/NotFound';
import PaddedPage from 'components/shared/PaddedPage';
import PropTypes from 'prop-types';
import React from 'react';

const StaffRoute = ({
  component: TheComponent,
  isFetchingAccount,
  account,
  render,
  ...props
}) => {
  return (
    <Route
      {...props}
      render={props => {
        if (typeof account === 'undefined') return <PaddedPage {...props} />;
        if (account === null) return <LoginRedirect {...props} />;
        if (!account?.data?.isStaff) return <NotFound {...props} />;
        return render ? render(props) : <TheComponent {...props} />;
      }}
    />
  );
};

StaffRoute.contextTypes = {
  component: PropTypes.object
};

export default withRouter(
  withAuth(
    connect()(StaffRoute)
  )
);
